/**************************************************************************************************************************************************
*   MODULE NAME     :  LockedAbstracts
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  15-02-2021
*   DESCRIPTION     :  Component to load Locked Abstract page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { FaUnlockAlt, FaSpinner } from 'react-icons/fa'
import swal from "sweetalert";
import { Row, Col, Button, OverlayTrigger, Tooltip, } from 'react-bootstrap';
import DataTableSelectRow from '../common/dataTable/DataTableSelectRow';
import { getAllLockedAbstractData, unlockAbstract } from "../../actions/abstractActions";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import * as MessagePool from '../common/MessagesPool';

const LockedAbstracts = (props) => {

    const [selectedAbstracts, setSeletedAbstracts] = useState([])
    const [lockedAbstractsList, setLockedAbstractsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const lockedAbstractsDataColumns = [
        {
            dataField: 'abstractId',
            hidden: true,
            sort: true
        },
        {
            dataField: 'abstract.title',
            text: 'Title',
            sort: true,
            align: 'left',
            formatter: (cellContent, row) => {
                return row && row.abstract ? row.abstract.title : ''
            }
        },
        {
            dataField: 'lockedBy',
            text: 'System ID',
            sort: true,
            align: 'left',
        },
        {
            dataField: 'locker.firstName',
            text: 'Name',
            sort: true,
            align: 'left',
            formatter: (cellContent, row) => {
                return row && row.locker ? `${row.locker.firstName} ${row.locker.lastName}` : ''
            }
        },
        {
            dataField: 'lockedAt',
            text: 'Date',
            sort: true,
            align: 'left',
            formatter: (cellContent, row) => {
                return row && row.lockedAt ? ddmmmyyyyFormat(row.lockedAt) : ''
            }
        }]

    /****  
     * useEffect hook : Similar to componentDidMount and componentDidUpdate
     ****/
    useEffect(() => {
        loadAllAbstractData();
    }, []);

    const loadAllAbstractData = async () => {
        setIsLoading(true);
        props.getAllLockedAbstractData().then(res => {
            if (res && res.data && res.data.result) {
                setLockedAbstractsList(res.data.result)
                setIsLoading(false);
            }
        });
    }


    const handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            setSeletedAbstracts([...selectedAbstracts, +row.abstractId])
        } else {
            setSeletedAbstracts(selectedAbstracts.filter(x => x !== +row.abstractId))
        }
    }

    const handleOnSelectAll = (isSelect, rows) => {
        const ids = rows.map(r => +r.abstractId);
        if (isSelect) {
            setSeletedAbstracts(ids)
        } else {
            setSeletedAbstracts([])
        }
    }

    const unlockAbstractFunction = async () => {
        setIsLoading(true);
        try {
            if (selectedAbstracts.length > 0) {
                let payload = { abstractIds: selectedAbstracts }
                let res = await props.unlockAbstract(payload);
                if (res.status === 200) {
                    setIsLoading(false);
                    setSeletedAbstracts([]);
                    loadAllAbstractData();
                    swal('', MessagePool.UNLOCK_ABSTRACT_SUCCESS, 'success');
                } else {
                    setIsLoading(false);
                    swal('Oops !', MessagePool.SERVER_ERROR, 'error');
                }
            }
        } catch (err) {
            setIsLoading(false);
        }
    }

    return (
        <div className="savedSearchList">
            <Row>
                <Col className="btns text-right">
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip>Unlock Abstracts</Tooltip>}
                    >
                        <Button
                            className="addBtn mr-2"
                            disabled={selectedAbstracts.length < 1}
                            onClick={() =>
                                unlockAbstractFunction()
                            }
                            variant="outline-dark"
                        >
                            <FaUnlockAlt />
                        </Button>
                    </OverlayTrigger>
                </Col>
            </Row>


            <DataTableSelectRow
                keyField="abstractId"
                defaultSortField="lockedAt"
                data={lockedAbstractsList}
                columns={lockedAbstractsDataColumns}
                handleOnSelect={handleOnSelect}
                handleOnSelectAll={handleOnSelectAll}
            />
            {isLoading && (
                <div className="loader">
                    <FaSpinner />
                </div>
            )}
        </div>

    );
}

const mapStateToProps = state => {
    return {
    };
};


const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            getAllLockedAbstractData,
            unlockAbstract
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LockedAbstracts));
